"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridV4FuturesShareRatio = void 0;
const common_business_1 = require("@pionex-web-kit/common-business");
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const trade_utils_lib_1 = require("trade_utils_lib");
var GridV4FuturesShareRatio;
(function (GridV4FuturesShareRatio) {
    /**
     * 通过分享id获取订单参数
     */
    GridV4FuturesShareRatio.getOrderInfoByShareId = (id, authType = trade_utils_lib_1.AuthType.None) => {
        return trade_utils_lib_1.Network.get({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().kolFApi}/trading_bot_order?unique_id=${id}`,
            authType,
        }).pipe((0, rxjs_1.map)((r) => {
            var _a, _b, _c, _d, _e;
            if ((r === null || r === void 0 ? void 0 : r.bu_order_type) === TradeAPILib_1.ExchangeOrderType.gridV4Futures || (r === null || r === void 0 ? void 0 : r.bu_order_type) === TradeAPILib_1.ExchangeOrderType.copy_bot) {
                const exchangeOrder = TradeAPILib_1.TradeUtils.convertToExchangeOrder(Object.assign(Object.assign({}, (_a = r === null || r === void 0 ? void 0 : r.order_data) === null || _a === void 0 ? void 0 : _a.payload), { bu_order_type: r === null || r === void 0 ? void 0 : r.bu_order_type, bu_order_id: r === null || r === void 0 ? void 0 : r.bu_order_id, bu_order_data: Object.assign(Object.assign({}, (_c = (_b = r === null || r === void 0 ? void 0 : r.order_data) === null || _b === void 0 ? void 0 : _b.payload) === null || _c === void 0 ? void 0 : _c.bu_order_data), { create_time: r === null || r === void 0 ? void 0 : r.order_create_time, close_time: r === null || r === void 0 ? void 0 : r.order_end_time, share_ratio: r === null || r === void 0 ? void 0 : r.shared_ration, share_mode: r === null || r === void 0 ? void 0 : r.share_mode }) }));
                if (!exchangeOrder) {
                    throw "error order type";
                }
                return {
                    bu_order_id: r === null || r === void 0 ? void 0 : r.bu_order_id,
                    order_share_id: r === null || r === void 0 ? void 0 : r.unique_id,
                    user_info: {
                        nickname: r === null || r === void 0 ? void 0 : r.nick_name,
                        head_path: r === null || r === void 0 ? void 0 : r.avatar,
                    },
                    allow_parameter_modify: r === null || r === void 0 ? void 0 : r.allow_parameter_hidden,
                    parseOrder: exchangeOrder,
                    orderFeedData: r,
                    share_code: ((_d = r === null || r === void 0 ? void 0 : r.extra_data) === null || _d === void 0 ? void 0 : _d.share_code) || (r === null || r === void 0 ? void 0 : r.share_code),
                    is_private: (_e = r === null || r === void 0 ? void 0 : r.extra_data) === null || _e === void 0 ? void 0 : _e.is_private,
                    user_id: r === null || r === void 0 ? void 0 : r.user_id,
                };
            }
            else {
                throw "error order type";
            }
        }));
    };
    /**
     * 通过订单id获取 订单分享参数
     * @param orderId 订单id
     * @returns
     */
    GridV4FuturesShareRatio.getOrderShareInfo = (orderId) => {
        return trade_utils_lib_1.Network.get({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().kolFApi}/fetch_or_create_trading_bot_order`,
            data: {
                bu_order_id: orderId,
                bu_order_type: TradeAPILib_1.ExchangeOrderType.gridV4Futures,
            },
            authType: trade_utils_lib_1.AuthType.Access,
        }).pipe((0, rxjs_1.map)((r) => ({
            fee_rate: r.fee_rate,
            allow_parameter_hidden: r.allow_parameter_hidden,
            share_ratio: r.shared_ration,
            shared_id: r.unique_id,
            extra_data: r.extra_data,
        })));
    };
    /**
     * 保存/编辑分享机器人
     */
    GridV4FuturesShareRatio.submitOrderShareInfo = (params) => {
        return trade_utils_lib_1.Network.post({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().kolFApi}/trading_bot_order`,
            data: {
                bu_order_id: params.bu_order_id,
                bu_order_type: TradeAPILib_1.ExchangeOrderType.gridV4Futures,
                share_ratio: params.share_ratio,
                fee_rate: params.fee_rate,
                allow_parameter_hidden: params.allow_parameter_hidden,
                extra_data: params.extra_data,
            },
            authType: trade_utils_lib_1.AuthType.Access,
        });
    };
    /**
     * 通过分享id获取分享链接
     */
    GridV4FuturesShareRatio.getShareUriBySharedId = (sharedId, locale) => {
        return `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().shareHost}/s/${sharedId}${locale ? `?l=${locale}` : ""}`;
    };
    /**
     * 获取 分润比例配置
     * @param param0
     * @returns
     */
    GridV4FuturesShareRatio.getRatioConfig = (module_tag) => {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().rebateHost}/v2/kol/benefit/rule/config?module_tag=${module_tag}`;
        return trade_utils_lib_1.Network.get({ url, authType: trade_utils_lib_1.AuthType.Access });
    };
    GridV4FuturesShareRatio.useSharedInfo = ({ orderId, locale, referralCode, onInit, }) => {
        const [data, setData] = (0, react_1.useState)();
        const [loadingShareInfo, setLoadingShareInfo] = (0, react_1.useState)();
        const [ratioConfig, setRatioConfig] = (0, react_1.useState)();
        const [loadingRatioConfig, setLoadingRatioConfig] = (0, react_1.useState)();
        const dataForUI = (0, react_1.useMemo)(() => {
            var _a;
            const fmtValue = (v) => {
                if (!v) {
                    return "";
                }
                if (new trade_utils_lib_1.SafeDecimal(v).eq(0)) {
                    return `${v}`;
                }
                return new trade_utils_lib_1.SafeDecimal(v).mul(100).toString();
            };
            return {
                // 当前用户分润规则配置
                ratioConfig: fmtValue(ratioConfig),
                // 当前订单分润设置
                ratio: fmtValue(data === null || data === void 0 ? void 0 : data.share_ratio),
                // 当前订单手续费设置
                fee: fmtValue(data === null || data === void 0 ? void 0 : data.fee_rate),
                // 当前订单是否允许修改参数
                allowParamsModify: !!(data === null || data === void 0 ? void 0 : data.allow_parameter_hidden),
                // 当前订单分享链接
                shareUri: (data === null || data === void 0 ? void 0 : data.shared_id) ? GridV4FuturesShareRatio.getShareUriBySharedId(data.shared_id, locale) : undefined,
                // 当前订单是否仅让被邀请的用户跟单
                isPrivate: !!((_a = data === null || data === void 0 ? void 0 : data.extra_data) === null || _a === void 0 ? void 0 : _a.is_private) ? true : false,
            };
        }, [data, ratioConfig, locale]);
        (0, react_1.useEffect)(() => {
            setLoadingShareInfo(true);
            GridV4FuturesShareRatio.getRatioConfig("share_for_get_money").subscribe({
                next(value) {
                    setRatioConfig(value.benefit_rate);
                    setLoadingRatioConfig(false);
                },
                error(err) {
                    setLoadingRatioConfig(false);
                },
            });
        }, []);
        (0, react_1.useEffect)(() => {
            setLoadingShareInfo(true);
            GridV4FuturesShareRatio.getOrderShareInfo(orderId).subscribe({
                next: (r) => {
                    var _a;
                    const res = Object.assign(Object.assign({}, r), { extra_data: ((_a = r === null || r === void 0 ? void 0 : r.extra_data) === null || _a === void 0 ? void 0 : _a.share_code) ? r.extra_data : Object.assign(Object.assign({}, r.extra_data), { share_code: referralCode || "" }) });
                    onInit === null || onInit === void 0 ? void 0 : onInit(res);
                    setData(res);
                    setLoadingShareInfo(false);
                },
                error: () => {
                    setLoadingShareInfo(false);
                },
            });
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [orderId]);
        const setSharedProfit = (0, common_business_1.usePersistFn)((v) => {
            setData((s) => (Object.assign(Object.assign({}, s), { share_ratio: new trade_utils_lib_1.SafeDecimal(v).eq(0) ? v : new trade_utils_lib_1.SafeDecimal(v).div(100).toNumber() })));
        });
        const setFeeRate = (0, common_business_1.usePersistFn)((v) => {
            setData((s) => (Object.assign(Object.assign({}, s), { fee_rate: new trade_utils_lib_1.SafeDecimal(v).eq(0) ? v : new trade_utils_lib_1.SafeDecimal(v).div(100).toNumber() })));
        });
        const setAllowParamsModify = (0, common_business_1.usePersistFn)(() => {
            setData((s) => (Object.assign(Object.assign({}, s), { allow_parameter_hidden: !(s === null || s === void 0 ? void 0 : s.allow_parameter_hidden) })));
        });
        const setIsPrivate = (0, common_business_1.usePersistFn)(() => {
            setData((s) => {
                var _a;
                return (Object.assign(Object.assign({}, s), { extra_data: Object.assign(Object.assign({}, s === null || s === void 0 ? void 0 : s.extra_data), { is_private: !!((_a = s === null || s === void 0 ? void 0 : s.extra_data) === null || _a === void 0 ? void 0 : _a.is_private) ? 0 : 1 }) }));
            });
        });
        const setShareCode = (0, common_business_1.usePersistFn)((v) => {
            setData((s) => (Object.assign(Object.assign({}, s), { extra_data: Object.assign(Object.assign({}, s === null || s === void 0 ? void 0 : s.extra_data), { share_code: v }) })));
        });
        const { feeRange, ratioRange } = (0, react_1.useMemo)(() => {
            const _ratioRange = { min: 0, max: 0.3 };
            const _feeRange = { min: 0.0002, max: 0.0005 };
            return { feeRange: _feeRange, ratioRange: _ratioRange };
        }, []);
        // 验证
        const errorMsg = (0, react_1.useMemo)(() => {
            const obj = {};
            if ((data === null || data === void 0 ? void 0 : data.share_ratio) &&
                !new trade_utils_lib_1.SafeDecimal(data === null || data === void 0 ? void 0 : data.share_ratio).eq(0) &&
                (new trade_utils_lib_1.SafeDecimal(data.share_ratio).lessThan(ratioRange.min) ||
                    new trade_utils_lib_1.SafeDecimal(data.share_ratio).greaterThan(ratioRange.max))) {
                obj.ratio = true;
            }
            if ((data === null || data === void 0 ? void 0 : data.fee_rate) &&
                !new trade_utils_lib_1.SafeDecimal(data === null || data === void 0 ? void 0 : data.fee_rate).eq(0) &&
                (new trade_utils_lib_1.SafeDecimal(data.fee_rate).lessThan(feeRange.min) || new trade_utils_lib_1.SafeDecimal(data.fee_rate).greaterThan(feeRange.max))) {
                obj.fee = true;
            }
            return obj;
        }, [data, feeRange, ratioRange]);
        const submit = (0, common_business_1.usePersistFn)(() => {
            if (Object.keys(errorMsg).length) {
                return (0, rxjs_1.throwError)({ code: -1, message: "input error" });
            }
            return GridV4FuturesShareRatio.submitOrderShareInfo({
                bu_order_id: orderId,
                fee_rate: new trade_utils_lib_1.SafeDecimal(data === null || data === void 0 ? void 0 : data.fee_rate).eq(0) ? undefined : data === null || data === void 0 ? void 0 : data.fee_rate,
                allow_parameter_hidden: data === null || data === void 0 ? void 0 : data.allow_parameter_hidden,
                share_ratio: new trade_utils_lib_1.SafeDecimal(data === null || data === void 0 ? void 0 : data.share_ratio).eq(0) ? undefined : data === null || data === void 0 ? void 0 : data.share_ratio,
                extra_data: data === null || data === void 0 ? void 0 : data.extra_data,
            });
        });
        return {
            data,
            dataForUI,
            errorMsg,
            setSharedProfit,
            setFeeRate,
            setAllowParamsModify,
            setShareCode,
            setIsPrivate,
            submit,
            loadingRatioConfig,
            loadingShareInfo,
            feeRange,
            ratioRange,
        };
    };
    // 检查tpsl 在按价格止盈止损时是否超出范围
    GridV4FuturesShareRatio.tpslAvailableCheck = ({ currentPrice, order }) => {
        const checkUp = (v) => {
            return new trade_utils_lib_1.SafeDecimal(currentPrice).greaterThan(v);
        };
        const checkDown = (v) => {
            return new trade_utils_lib_1.SafeDecimal(currentPrice).lessThan(v);
        };
        let tpAvailable = true;
        let slAvailable = true;
        // 止盈
        if ([TradeAPILib_1.GridStopType.price, TradeAPILib_1.GridStopType.price_limit].includes(order.profit_stop_type) &&
            order.trend !== TradeAPILib_1.GridFuturesTrend.no_trend) {
            const checkFn = order.trend === TradeAPILib_1.GridFuturesTrend.long ? checkUp : checkDown;
            if (order.trailing && checkFn(order.trailing)) {
                tpAvailable = false;
            }
        }
        // 止损
        if ([TradeAPILib_1.GridStopType.price, TradeAPILib_1.GridStopType.price_limit].includes(order.loss_stop_type)) {
            const checkFn = TradeAPILib_1.GridFuturesTrend.short !== order.trend ? checkDown : checkUp;
            if (order.stop && checkFn(order.stop)) {
                slAvailable = false;
            }
            // 中性网格 stopHigh stopHighLimit 检查
            if (order.trend === TradeAPILib_1.GridFuturesTrend.no_trend && order.stopHigh && checkUp(order.stopHigh)) {
                slAvailable = false;
            }
        }
        return { tpAvailable, slAvailable };
    };
})(GridV4FuturesShareRatio || (exports.GridV4FuturesShareRatio = GridV4FuturesShareRatio = {}));
